<!-- <template>
  <main class="main__home home" ref="home">
    <div class="home__intro intro" ref="$homeIntro">
      <div>
        <img :src="mediaPath(page.intro_image)" class="intro__background" :alt="$store.getters.page.title" :title="$store.getters.page.title" />
      </div>
      <div class="intro__overlay" :class="{'is-ready':heroReady}" />
      <div class="intro__content container" :class="{'is-ready':heroReady}">
        <h1 :class="{'is-ready':heroReady}">{{$store.getters.page.meta_title}}</h1>
      </div>
      <div class="intro__scrollto scrollto" @click="doScroll" :class="{'is-ready':heroReady}">
        <i class="scrollto__arrow" />
      </div>
    </div>
    <div style="background: #F0E5DC;">
      <div class="favorites__container container">
        <h1 v-text="page.title" :class="{'is-ready':heroReady}" />
        <div class="intro__text" v-html="page.intro_text" style="text-align: center;" :class="{'is-ready':heroReady}"/>
      </div>
    </div>
    <favorites class="home__favorites" :page="page" v-if="page.favorites.length"
      ref="$homeFavorites" />
  </main>
</template> -->
<template>
  <main class="main__home home" ref="home">
    <div class="home__intro intro" ref="$homeIntro">
      <div>
        <img :src="mediaPath(page.intro_image)" class="intro__background" :alt="$store.getters.page.title" :title="$store.getters.page.title" />
      </div>
      <div class="intro__overlay" :class="{'is-ready':heroReady}" />
      <div class="intro__content container" :class="{'is-ready':heroReady}">
        <h1 :class="{'is-ready':heroReady}">{{$store.getters.page.meta_title}}</h1>
        <div class="intro__text" v-html="page.intro_text" :class="{'is-ready':heroReady}"
        />
      </div>
      <div class="intro__scrollto scrollto" @click="doScroll" :class="{'is-ready':heroReady}">
        <i class="scrollto__arrow" />
      </div>
    </div>
    <favorites class="home__favorites" :page="page" v-if="page.favorites.length"
      ref="$homeFavorites" />
  </main>
</template>


<script>
import imagesLoaded from 'imagesloaded'
import anime from 'animejs'

import page from '@/mixins/page'

import Favorites from '@/components/Favorites'

/* eslint-disable no-unused-vars */
// import { TweenLite } from 'gsap'
// import EasePack from 'gsap/EasePack'
// import ScrollToPlugin from 'gsap/ScrollToPlugin'

export default {
  mixins: [page],
  name: 'Home',
  components: {
    Favorites
  },
  data() {
    return {
      heroReady: false
    }
  },
  directives: {
    imagesLoaded
  },
  methods: {
    doScroll() {
      anime({
        duration: 1000,
        targets: '[data-page]',
        easing: 'easeOutSine',
        scrollTop: this.$refs.$homeIntro.clientHeight
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.heroReady = true
      }, 500)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/HomeTemplate.vue